import { createContext, useContext, useState } from "react";


const ShopContext = createContext();



export function ShopProvider({children}){


const [cart,setCart] = useState([]);

const [favorites,setFavorites] = useState([]);




// عدد السلة

const cartCount = cart.reduce(
(total,item)=> total + item.quantity,
0
);




// =====================
// ADD TO CART
// =====================

const addToCart = (product)=>{


setCart(prev=>{


const exists = prev.find(item=>

item.id === product.id &&

item.color === product.color &&

item.size === product.size

);




if(exists){


return prev.map(item=>

item.id === product.id &&

item.color === product.color &&

item.size === product.size


?

{

...item,

quantity:item.quantity + 1

}


:

item

);


}




return [

...prev,

{

...product,

quantity:1

}

];


});


};






// =====================
// PLUS
// =====================


const increaseQty = (id,color,size)=>{


setCart(prev=>

prev.map(item=>


item.id===id &&

item.color===color &&

item.size===size


?

{

...item,

quantity:item.quantity+1

}


:

item


)

);


};






// =====================
// MINUS
// =====================


const decreaseQty = (id,color,size)=>{


setCart(prev=>

prev.map(item=>


item.id===id &&

item.color===color &&

item.size===size &&

item.quantity>1


?

{

...item,

quantity:item.quantity-1

}


:

item


)

);


};






// =====================
// DELETE
// =====================


const removeFromCart=(id,color,size)=>{


setCart(prev=>

prev.filter(item=>

!(

item.id===id &&

item.color===color &&

item.size===size

)

)

);


};







// =====================
// FAVORITES
// =====================


const toggleFavorite=(product)=>{


setFavorites(prev=>{


const exists = prev.find(item=>

item.id===product.id

);



if(exists){


return prev.filter(item=>

item.id!==product.id

);


}



return [

...prev,

product

];


});


};





const removeFavorite=(id)=>{


setFavorites(prev=>

prev.filter(item=>

item.id!==id

)

);


};







return(


<ShopContext.Provider


value={{


cart,

cartCount,


addToCart,

increaseQty,

decreaseQty,

removeFromCart,


favorites,

toggleFavorite,

removeFavorite


}}


>


{children}


</ShopContext.Provider>


);


}





export function useShop(){


return useContext(ShopContext);


}